import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import stolenCardImage01 from "@/assets/images/help/stolen-card-01.png";
import stolenCardImage02 from "@/assets/images/help/stolen-card-02.png";

export default function HelpStolenCard() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            Guide to Reporting a Stolen Card
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Report a Lost or Stolen Card
              {"\n\n"}If your card is lost or stolen, report it immediately to
              block it for security.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 1: Start the Report</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              Go to Fellas Card → My Card and click the "Report Stolen" button
              to open the report screen.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={stolenCardImage01}
                alt="Stolen Card Report Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 2: Complete the Report</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Verify your card and press the "Report Stolen" button to complete
              the report.
              {"\n\n\n"}⚠️Once your report is submitted, the card will be
              immediately suspended to prevent unauthorized use.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={stolenCardImage02}
                alt="Stolen Card Report Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/14")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: View Transaction History</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
